var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('universal-uploader',{staticClass:"text-truncate",on:{"uploadSuccess":_vm.uploadSuccess}},[_c('b-btn',{staticClass:"d-flex align-items-center",attrs:{"variant":"light","pill":"","size":"sm"}},[_c('font-awesome-icon',{staticClass:"mr-1",attrs:{"icon":"fa-duotone fa-camera"}}),_vm._v(" "+_vm._s(_vm.$t("Photo"))+" ")],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }